import { useState } from "react";
import { LabelWithYears } from "common";
import { Button } from "components";
import { useIntl } from "react-intl";

import "./DoctorRenderList.scss";

interface List {
  attributes: {
    years: string;
    title: string;
  };
  key: string;
}

interface DoctorRenderListProps {
  title: string;
  list: Array<List>;
}

export const DoctorRenderList = ({ title, list }: DoctorRenderListProps) => {
  const [visibleItems, setVisibleItems] = useState(6);

  const handleLoadMore = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 6);
  };
  const { formatMessage } = useIntl();
  return (
    <div className="doctor-render-list">
      <div className="doctor-render-list__title">{title}</div>
      <div className="doctor-render-list__list">
        {list?.slice(0, visibleItems).map((item) => (
          <LabelWithYears
            key={item?.key}
            years={item?.attributes?.years}
            text={item?.attributes?.title}
            className="doctor-render-list__item"
          />
        ))}
        {list.length > visibleItems && (
          <Button className="doctor-render-list__item__button button" onClick={handleLoadMore}>
            {formatMessage({
                id: "doctors.modal.see-more",
                defaultMessage: "_SeeMore_",
              })}
          </Button>
        )}
      </div>
    </div>
  );
};
